import React, { useContext, useEffect, useState } from "react";
import styles from "./EmailAccCreatedPopup.module.css";
import emailIcon from "../../assests/emailIcon.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
import singinCloseButton from "../../assests/singinCloseButton.svg";
import success from "../../assests/share/copySuccessRound.svg";
import Context from "../../context/Context";

const EmailAccCreatedPopup = ({ setPopup }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const [verified, setVerified] = useState(false);
  const {
    emailVerification,
    emailVerificationGoviral,
    currentUser,
    pageLoading,
    setPageLoading,
    emailError,
    setEmailError,
    emailVerified,
    fetchUserData,
    verifyEmailOtp,
  } = useUserAuth();
  const { details } = useContext(Context);
  const [otp, setOtp] = useState();

  // useEffect(() => {
  //   const intervalId = setInterval(async () => {
  //     const userData = await fetchUserData();
  //     if (userData?.emailVerified == true) {
  //       setVerified(true);
  //       setPageLoading(false);
  //     }
  //   }, 5000);
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  const handleEmailVerification = () => {
    // emailVerification(currentUser);
    emailVerificationGoviral(currentUser?.email, currentUser?.accessToken);
  };

  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <div className="w-[100%] flex justify-end p-[10px] cursor-pointer">
          {(!details?.closedCampaign || emailVerified) && (
            <img
              src={singinCloseButton}
              onClick={() => {
                setEmailError(false);
                setPageLoading(false);
                setPopup(false);
              }}
            />
          )}
        </div>
        {/* <img
          src={LikedAlready}
          alt=""
          className="w-[56px] h-[56px] mb-[24px]  "
        /> */}
        {/* <p className="text-regular-medium px-[20px] mb-[16px]">
          Option to dislike is disabled
        </p> */}

        <h3 className="text-regular-medium mb-[14px]">
          Please verify your email
        </h3>
        <p className="text-small text-opacity-80 mb-[25px]">
          Almost there! An email containing verification instructions was sent
          to {currentUser?.email} from goviralit@gmail.com.
        </p>

        {emailVerified ? (
          <div className="text-regular-medium flex items-center w-full justify-center gap-[5px]">
            Verified <img src={success} alt="" className="w-[36px] h-[36px]" />
          </div>
        ) : (
          <>
            <p
              className="text-small cursor-pointer"
              onClick={handleEmailVerification}
              disabled={pageLoading}
            >
              Didn't receive the email?{" "}
              <span className="text-[#3075FC]">Resend email</span>
            </p>

            <div className="w-[80%]">
              <input
                type="number"
                id="otp"
                name="otp"
                placeholder="Enter OTP"
                className="text-regular-callout my-[16px]"
                onChange={(e) => setOtp(e.target.value)}
                value={otp}
              />
              <button
                className={`${styles.button} text-regular-medium bg-[#7AC280] flex items-center justify-center gap-[14px]                       `}
                onClick={() => verifyEmailOtp(otp)}
                disabled={pageLoading}
              >
                Submit OTP
              </button>
            </div>
          </>
        )}

        <div className="w-full p-[10px] flex flex-col items-center">
          {emailError && (
            <div className="text-small text-center w-[100%] mb-[12px]">
              <span className="text-red-600">*</span>
              {emailError}
            </div>
          )}
          {pageLoading && !emailVerified && <LoadingFromCenter />}
        </div>
      </div>
    </div>
  );
};

export default EmailAccCreatedPopup;
